export default "__VITE_ASSET__D54mGSzn__"